// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".category-img{height:150px;overflow:hidden;border-bottom-left-radius:10px;border-bottom-right-radius:10px}.category-img img{width:100%;height:100%;-o-object-fit:cover;object-fit:cover;display:block}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
